import React, { useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar";
import Navbar from "components/navbar";
import routes from "routes/routes";

export default function Admin() {
  const location = useLocation();
  const [open, setOpen] = useState(window.innerWidth >= 1200);
  const [currentRoute, setCurrentRoute] = useState("Main Dashboard");

  useEffect(() => {
    const handleResize = () => setOpen(window.innerWidth >= 1200);
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const active = routes.find((r) =>
      location.pathname.includes(`${r.layout}/${r.path}`)
    );
    setCurrentRoute(active?.name || "Main Dashboard");
  }, [location.pathname]);

  const activeNavbar = useMemo(() => {
    const active = routes.find((r) =>
      location.pathname.includes(`${r.layout}/${r.path}`)
    );
    return active?.secondary || false;
  }, [location.pathname]);

  const adminRoutes = useMemo(() => {
    return routes
      .filter((r) => r.layout === "/admin")
      .map((r, i) => (
        <Route path={`/${r.path}`} element={r.component} key={i} />
      ));
  }, []);

  document.documentElement.dir = "ltr";

  return (
    <div className="flex h-full w-full overflow-hidden">
      <Sidebar open={open} onClose={() => setOpen(false)} />

      <div className="flex h-full w-full flex-col items-start justify-start">
        <div className="w-full xl:ml-72 xl:w-[calc(100%-18rem)]">
          <Navbar
            onOpenSidenav={() => setOpen(true)}
            logoText="Admin Dashboard"
            brandText={currentRoute}
            secondary={activeNavbar}
          />
        </div>

        <div className="h-full w-full bg-gray-50 dark:!bg-navy-900">
          <main
            className={`mx-auto h-full w-full pt-[20px] xl:ml-72 xl:w-[calc(100%-18rem)]`}
          >
            <div className="h-full px-2 pb-5 md:px-4">
              <div className="mx-auto mb-auto h-full min-h-[84vh]">
                <Routes>
                  {adminRoutes}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/default" replace />}
                  />
                </Routes>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
